import { Modal } from '@numa-group/ui.modal';
import { useFormContext } from 'react-hook-form';

import styles from './search-location.module.css';
import { SearchProps } from '../../search';
import { SearchSchema } from '../../search.schema';

type SearchLocationProps = {
  locations: SearchProps['cities'];
  onSelect: VoidFunction;
};
export const SearchLocation = ({ locations, onSelect }: SearchLocationProps) => {
  const form = useFormContext<SearchSchema>();
  const input = form.register('location');

  return (
    <Modal.Body>
      <Modal.Content>
        {locations.map(({ cityName, slug }) => (
          <label key={slug} className={styles.location}>
            <span>{cityName}</span>
            <input
              type="radio"
              value={slug}
              {...input}
              onChange={async (e) => {
                await input.onChange(e);
                onSelect();
              }}
            />
          </label>
        ))}
      </Modal.Content>
    </Modal.Body>
  );
};
